import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { ContactModelInterface } from '../models/contact';
import _ from 'lodash';

export interface ContactState {
  model: ContactModelInterface;
}

const initialState: ContactState = {
  model: {
    route: 'ck_contact',
    fullCkiProcess: false,
    passengers: [],
    segments: [],
    messages: {},
    contactReuse: false,
    contactReusePaxId: 0,
    selectedPaxId: 0,
    passengerValidMessage: undefined,
  },
};

export const contactSlice = createSlice({
  name: 'contact',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    resetContactModel: (state) => {
      return initialState;
    },
    setContactModel: (state, action) => {
      state.model = action.payload;
    },
    setContactModelAttribute: (state, action: PayloadAction<{ key: string; value: any }>) => {
      const key = action.payload.key;
      const value = action.payload.value;
      Object.assign(state.model, { [key]: value });
    },
    setContactPaxAttribute: (
      state,
      action: PayloadAction<{
        paxid: number;
        path: string | string[];
        value: any;
      }>
    ) => {
      const paxid = action.payload.paxid;
      const path = action.payload.path;
      const value = action.payload.value;
      let pax = state.model.passengers.find((x) => x.paxIdReference === paxid);
      if (pax) {
        _.set(pax, path, value);
      }
    },
    resetMesages: (state) => {
      state.model.messages = null;
    },
  },
});

export const {
  setContactModel,
  setContactModelAttribute,
  resetMesages,
  resetContactModel,
  setContactPaxAttribute,
} = contactSlice.actions;

export const selectContactModel = (state: RootState) => state.contact.model;

export default contactSlice.reducer;
